// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"grid-add"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M10 3H3V10H10V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14 3H21V10H14V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M10 14H3V21H10V14Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10 3H3V10H10V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M14 3H21V10H14V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10 14H3V21H10V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.5 14.5V17.5M17.5 17.5V20.5M17.5 17.5H14.5M17.5 17.5H20.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GridAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'grid-add',
    ref,
    icon: element,
  },
));

GridAddIcon.displayName = 'GridAddIcon';

export default GridAddIcon;
